<template>
    <main class="main-content main-content-bg mt-0">
        <div class="page-header min-vh-100" style="
        background-image: url('/brasal/bg-espaco-cliente.jpg');
      ">
            <span class="mask bg-gradient-dark opacity-6"></span>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-4 col-md-7 mt-2">
                        <div class="card border-0 mb-0">
                            <div class="card-header bg-transparent d-flex justify-content-center align-items-center">
                                <img :src="logo" :class="segment" alt="Logo Brasal" />
                            </div>

                            <div class="card-body px-lg-5 pt-0 align-items-center text-center">
                                <div class="mt-1 mb-4">
                                    <div class="">
                                        <span style="font-size: 16px;"
                                            class="segment-primary-color font-weight-bolder">Esqueci minha
                                            senha</span>
                                    </div>
                                    <div style="font-size: 10px;" class="mt-2">
                                        Preencha os campos abaixo para receber um e-mail de redefinição dos dados de
                                        acesso ao Espaço
                                        Cliente.
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <argon-input id="cpfCnpj" type="text" placeholder="Confirme seu CPF ou CNPJ"
                                        v-model="cpfCnpj" aria-label="Confirme seu CPF ou CNPJ"
                                        v-maska="['###.###.###-##', '##.###.###/####-##']" />
                                </div>
                                <div class="mb-3">
                                    <argon-input id="email" type="email" placeholder="Confirme seu e-mail"
                                        v-model="email" aria-label="Confirme seu e-mail" />
                                </div>

                                <div class="text-center">
                                    <argon-button @click.prevent="resetPassword" :disabled="loadingButton"
                                        color="primary" full-width class="my-4 mb-2">Recuperar Senha <i
                                            v-if="loadingButton"
                                            class="fa fa-spinner fa-pulse fa-fw"></i></argon-button>
                                </div>
                                <div class="mb-2 position-relative text-center">
                                    <p class="text-sm mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3">
                                        ou
                                    </p>
                                </div>
                                <div class="text-center">
                                    <router-link :to="{ name: 'Login' }" class="white font-weight-bold">
                                        <argon-button color="dark" full-width class="mt-2 mb-4 hover"
                                            style="background-color: #212329;">
                                            Voltar
                                        </argon-button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>

</template>

<script setup>
import { onBeforeMount, onBeforeUnmount, ref } from "vue";
import { useStore } from "vuex";
import axios from 'axios'
import { showToast } from "@/assets/js/toast.js";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const segment = process.env.SEGMENT
const store = useStore();
const toggleDefaultLayout = () => store.commit("toggleDefaultLayout");

const cpfCnpj = ref(null)
const email = ref(null)
const loadingButton = ref(false)

import logo from "@/assets/img/logos/brasal/brasal_incorporacoes.png";


const resetPassword = async () => {

    try {
        if (!cpfCnpj.value || !email.value) {
            showToast('Campos obrigatórios não preenchidos.', 'error');
            return;
        }
        let data = {
            cpfCnpj: cpfCnpj.value,
            email: email.value
        }
        loadingButton.value = true
        const response = await axios.post(`/auth/request-reset-password`, data);
        console.log(response.data.errorMessage)
        if (!response.data.error) {
            showToast('Confira seu e-mail para redefinir sua senha e acessar o app', 'success');
            cpfCnpj.value = null
            email.value = null
        } else {
            showToast(response.data.errorMessage, 'error');
        }
    } catch (error) {
        showToast('Não foi possível enviar, tente novamente', 'error');
    } finally {
        loadingButton.value = false
    }
}


onBeforeMount(() => {
    store.state.hideConfigButton = true;
    toggleDefaultLayout();
});
onBeforeUnmount(() => {
    store.state.hideConfigButton = false;
    toggleDefaultLayout();
});
</script>

<style scoped>
.hover:hover {
    color: #9d91a5 !important;
}
</style>
